import {Component, Input, OnInit} from '@angular/core';
import {AttachmentType, getSelectableAttachmentTypes} from "../../../../../models/antrag-ticket/AttachmentType";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AntragTicketService} from "../../../../../@core/services/antrag-ticket/antrag-ticket.service";
import {AntragAttachmentAdjustDto} from "../../../../../models/antrag-ticket/AntragAttachmentAdjustDto";
import {CustomToastService} from "../../../../../@core/utils/custom-toast.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-attachment-type-adjust',
    templateUrl: './attachment-type-adjust.component.html',
    styleUrl: './attachment-type-adjust.component.scss',
    standalone: false
})
export class AttachmentTypeAdjustComponent implements OnInit{
  @Input()
  antragId: string;
  @Input()
  attachmentId: string;
  public dateiForm: UntypedFormGroup;

  activeAttachmentTypes: AttachmentType[] = getSelectableAttachmentTypes();
  constructor(
    private fb: UntypedFormBuilder,
    private modalService: NgbActiveModal,
    private antragTicketService: AntragTicketService,
    private customToastService: CustomToastService,
    private translateService: TranslateService
  ){
  }

  ngOnInit() {
    this.dateiForm = this.fb.group({
      type: [null,[Validators.required]],
    });
  }


  reject(){
    this.modalService.close();
  }

  accept(){
    if(!this.dateiForm.valid){
      this.customToastService.showError(this.translateService.instant('ATTACHMENT.ATTACHMENTTYPE_MISSING'));
      return;
    }
    const dto: AntragAttachmentAdjustDto = {
      attachmentType: this.dateiForm.get('type')?.value.length !== 0 ? this.dateiForm.get('type')?.value : null,
      attachmentId: this.attachmentId
    };
    this.antragTicketService.adjustAttachmentType(this.antragId, dto );
    this.modalService.close();
  }

}
